//Это компонент-обёртка над компонентом Input
//Нужен, чтобы ограничить ввод: не допускать никакие символы кроме цифр (в том числе, исключить e, + и -)
//Компонент InputNumber не подходит из-за отсутствия пропа allowClear
// Компонент должен использоваться внутри Form.Item

import React from "react";
import { Input, InputProps } from "antd";

export const UI_ITONumericInput = (props: InputProps) => {
  const { onChange } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cleanedValue = e.target.value.replace(/\D/g, "").trim(); // Удаляем все, кроме цифр

    e.target.value = cleanedValue; // Обновляем значение в event'е

    if (onChange) onChange(e);
  };

  return <Input {...props} onChange={handleChange} />;
};
